import { usdCurrencyFormat } from '../../resources/functions';
import type { DecimalAmount } from './types';

/** Plain decimal only: optional minus, digits, up to two fraction digits. */
const PLAIN_DECIMAL_RE = /^-?\d+(\.\d{1,2})?$/;
const PLACEHOLDER = '--';

/**
 * Normalize an API money value to a fixed two-decimal string.
 * Strings are validated by regex before Number(), so hex, exponent, separators
 * and excess precision are rejected. Numbers must be finite. Anything else is null.
 */
export function toMoneyValue(value: unknown): DecimalAmount | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value.toFixed(2) : null;
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!PLAIN_DECIMAL_RE.test(trimmed)) return null;
  return Number(trimmed).toFixed(2);
}

/** Display a money value; anything that is not a valid normalized amount shows the placeholder. */
export function displayMoney(value: DecimalAmount | null | undefined): string {
  if (value === null || value === undefined) return PLACEHOLDER;
  const normalized = toMoneyValue(value);
  return normalized === null ? PLACEHOLDER : usdCurrencyFormat(Number(normalized));
}
